import { Box, Paper } from "@mui/material";
import siteImages from "../../data/siteImages";

const PartnerLogos = () => (
  <Box
    sx={{
      width: "100%",
      display: "flex",
      flexDirection: { xs: "column", lg: "row" },
      justifyContent: { xs: "center", lg: "space-between" },
      alignItems: "center",
      p: 4
    }}>
    {siteImages.aboutLogos.map((logo, index: number) => (
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }} key={index}>
        <Box
          component={"img"}
          src={logo.src}
          alt={logo.alt}
          sx={(theme) => ({
            my: { xs: 3, lg: 0 },
            mx: { xs: 0, lg: 3 },
            height: { xs: "auto", lg: theme.spacing(10) },
            width: "auto",
            maxWidth: { xs: theme.spacing(40), md: "none" },
            transition: "all 0.3s ease-in-out",
            filter: "grayscale(100%)",
            "&:hover": {
              filter: "grayscale(0%)"
            }
          })}
        />
      </Box>
    ))}
  </Box>
);

const ImportantPartners = ({ wrapper = true }: { wrapper?: boolean }) => {
  return wrapper ? (
    <Paper
      sx={{
        width: "100%"
      }}>
      <PartnerLogos />
    </Paper>
  ) : (
    <PartnerLogos />
  );
};

export default ImportantPartners;
